/*
 * Copyright © 2020-2024 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: garry彭
 * @LastEditTime: 2024-04-22 11:47:31
 */
import { Modal, Input, Form, message } from 'antd'
import React, { useState } from 'react'
import { emailReg } from '../lib/constants'
import { useAppDispatch } from '../../../app/hooks'
import { sendEmail } from '../../../actions/invoice'
import AntdProvider from '../../../components/AntdProvider'

interface SendEmailDialogProps {
  visible: boolean
  outOrderNo: string
  onClose: () => void
}

const SendEmailDialog: React.FC<SendEmailDialogProps> = ({ visible, outOrderNo, onClose }) => {
  const [form] = Form.useForm()
  const [loading, setLoading] = useState(false)
  const dispatch = useAppDispatch()

  const handleOk = async () => {
    try {
      const values = await form.validateFields()
      setLoading(true)

      dispatch(
        sendEmail({
          email: values.email,
          outOrderNo
        })
      )
        .then(() => {
          message.success('已发送至邮箱，请注意查收')
          setLoading(false)
          onClose()
        })
        .catch((e) => {
          console.log(e)
          setLoading(false)
        })
    } catch (e) {
      // 表单验证失败
    }
  }

  return (
    <AntdProvider>
      <Modal
        open={visible}
        confirmLoading={loading}
        title="发送至邮箱"
        okText="发送"
        onCancel={onClose}
        mask={{ closable: false }}
        onOk={handleOk}
      >
        <Form form={form} layout="vertical">
          <Form.Item
            name="email"
            rules={[
              {
                required: true,
                message: '请输入邮箱地址'
              },
              {
                validator: async (_, value) => {
                  if (value && !emailReg.test(value)) {
                    throw new Error('请输入正确格式的邮箱')
                  }
                }
              }
            ]}
          >
            <Input placeholder="请输入邮箱地址" />
          </Form.Item>
        </Form>
      </Modal>
    </AntdProvider>
  )
}

export default SendEmailDialog
